import React, { Suspense, useContext } from 'react'
import CONFIGS from 'build/Config'
import { LoaderContext } from 'contexts/loader-context'

const Footer = () => {
  const { footer } = useContext(LoaderContext)

  const version = CONFIGS.versionPh || 'v1'

  const FooterVersion = React.lazy(() => import(`components/footer/${version}`))

  if (!footer) {
    return null
  }

  return (
    <Suspense fallback={<></>}>
      <FooterVersion />
    </Suspense>
  )
}

export default Footer
